import {
    Component,
    OnInit,
    AfterViewInit, OnDestroy, AfterViewChecked,
    Output,
    EventEmitter,
    Input,
    ViewChild,
    Renderer2,
    HostListener, ElementRef
} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {CommonDataService} from 'app/services/common-data.service';

import * as Popper from 'popper.js/dist/umd/popper';
import * as moment from "moment";
import {PeriodSelectorModel} from "../../models/period-selector-model";
import {MainHelper} from "../../models/main-helper";

type InitialData = { accessDenied: boolean, rights: any };

@Component({
    selector: 'period-selector',
    templateUrl: './period-selector.component.html',
    styleUrls: ['./period-selector.component.css']
})
export class PeriodSelectorComponent implements OnInit, AfterViewInit, OnDestroy, AfterViewChecked{
    constructor(public readonly translateService: TranslateService,
                private readonly renderer: Renderer2,
                public readonly commonData: CommonDataService,
    ){
        this.helper = new MainHelper();
        // this.hide = new EventEmitter<{ startDate: string, endDate: string }>();
        this.updPopperOut = new EventEmitter<boolean>();
        this.datesOut = new EventEmitter<PeriodSelectorModel>();
        this.initialise();
    }

    private initialise = (): void =>{
        this._startDate = '';
        this._endDate = '';
        this.type = '0';
        this.daysQuantity = 92;
        this.flexWrap = false;
        this.clearValidation();
    };

    @Input() public inputClass: string;
    @Input() public sharedGUID: string;
    @Input() public GUID?: string;
    @Input() private btnRef: ElementRef;
    @Input() private wrpRef: ElementRef;
    @Input() private daysQuantity: number;
    @Input() private maxDaysCount: number;

    @Input()
    public set startDate(val: string){
        if (this._startDate !== val){
            this._startDate = val;

        }
    }

    public get startDate(){
        return this._startDate
    }

    @Input()
    public set endDate(val: string){
        if (this._endDate !== val){
            this._endDate = val;
        }
    }

    public get endDate(){
        return this._endDate
    }

    @Input()
    set popperUpdate(val: boolean){
        val && this.popperAddVar ? this.popperAddVar.update() : null;
    }

    //@Output()
    // private readonly hide: EventEmitter<{ startDate: string, endDate: string }>;

    @Output()
    private readonly updPopperOut: EventEmitter<boolean>;

    @Output()
    private readonly datesOut: EventEmitter<PeriodSelectorModel>;

    @ViewChild('mainWrapper')
    private mainWrapper: ElementRef;

    private helper: MainHelper;
    public _startDate: string;
    public _endDate: string;
    public startDateValid: string;
    public endDateValid: string;
    public daysQuantityValid: string;
    public model: any;
    public flexWrap: boolean;
    private setInterval: any;
    private mouseDown: boolean;
    private savedDQ: number;

    private popperAddVar: Popper;


    private _type: string;

    private listenContextMenu: () => void;
    private listenMouseDown: () => void;


    ngOnInit(){
        this.savedDQ = this.daysQuantity;
        this.maxDays('start');
    }

    ngOnDestroy(){
        clearInterval(this.setInterval);
        this.setInterval = null;
        this.listenContextMenu();
        this.listenMouseDown();
    }

    ngAfterViewInit(){
        this.helper.wait(() => this.checkWidth());
        this.setInterval = setInterval(() => this.checkWidth(), 1000)


        this.listenContextMenu = this.renderer.listen('body', 'contextmenu', (e: MouseEvent) => this.hideList(e));
        this.listenMouseDown = this.renderer.listen('body', 'mousedown', (e: MouseEvent) => this.hideList(e));
        this.popperAddVar = this.helper.popperAdd(this.btnRef, this.mainWrapper, this.wrpRef, 'bottom-start', ['bottom', 'bottom-end'], true)
    }

    ngAfterViewChecked(){
        // this.helper.wait(() => {
        //     if (this.mainWrapper && this.mainWrapper.nativeElement){
        //         if (this.isAdmin && this.mainWrapper.nativeElement.offsetWidth < 1000){
        //             this.flexWrap = true;
        //         } else if (!this.isAdmin && this.mainWrapper.nativeElement.offsetWidth < 760){
        //             this.flexWrap = true;
        //         } else {
        //             this.flexWrap = false;
        //         }
        //     }
        // })

    }

    @HostListener('window:mouseup', ['$event']) onMouseUp(e: MouseEvent){
        if (this.mouseDown){
            this.mouseDown = false;
        }
    }

    //# set needed daysQuantity proceeding user choise
    public set type(val: string){
        if (this._type !== val){
            this._type = val;
            switch (val){
                case '1':
                    this.daysQuantity = this.savedDQ;
                    break;
                case '2':
                    this.daysQuantity = this.savedDQ;
                    break;
                case '3':
                    this.daysQuantity = this.maxDaysCount;
                    break;
            }
            if (val === '3'){

            }

        }
    }

    public get type(){
        return this._type
    }

    //# change styles proceeding dimensions
    private checkWidth = (): void =>{
        if (this.mainWrapper && this.mainWrapper.nativeElement){

            if (this.mainWrapper.nativeElement.offsetWidth < 540){
                this.flexWrap = true;
            } else{
                this.flexWrap = false;
            }
            this.popperAddVar ? this.popperAddVar.update() : null;
        }
    }


    //# hide component if we click not in it
    private hideList = (e: MouseEvent): void =>{
        this.mouseDown = true;
        if (this.helper.hideList(this.mainWrapper, e, this.renderer)){
            this.helper.wait(() => this.datesOut.emit(null), 50);
        }
    };

    //# inner validation dates in inputs, or, update dates in inputs on init
    private maxDays = (change: string, validate: boolean = false): boolean =>{
        let endDate = moment.utc(this.endDate, "YYYY-MM-DD");
        let startDate = moment.utc(this.startDate, "YYYY-MM-DD");

        let ms = endDate.diff(startDate),
            d = moment.duration(ms),
            s = d.asDays();

        if (s < 0){
            return false;
        }

        if (validate){
            return true;
        }

        switch (change){
            case 'start':
                if (s > 0 && s <= this.maxDaysCount){
                    return true;
                } else if (s > this.maxDaysCount){
                    this.endDate = startDate.add(this.maxDaysCount, 'days').format('YYYY-MM-DD');
                    return true;
                }
                break;
            case 'end':
                if (s > 0 && s <= this.maxDaysCount){
                    return true;
                } else if (s > this.maxDaysCount){
                    this.startDate = endDate.add(-this.maxDaysCount, 'days').format('YYYY-MM-DD');
                    return true;
                }
                break;
        }
        return false;
    };

    private log = () =>{
        console.log(this.endDate, this.startDate, 'this.endDate, this.startDate')
    };

    private clearValidation = (): void =>{
        this.startDateValid = '';
        this.endDateValid = '';
        this.daysQuantityValid = '';
    }

    //# validate entered dates into inputs
    private validate = (): boolean =>{
        const wrongDate = 'Chart_WrongDate';
        this.clearValidation();
        switch (this.type){
            case '0':
                this.startDateValid = this.startDate ? '' : wrongDate;
                this.endDateValid = this.endDate ? '' : wrongDate;
                if (!this.maxDays('', true)){
                    this.startDateValid = wrongDate;
                    this.endDateValid = wrongDate;
                }
                break;
            case '1':
                this.startDateValid = this.startDate ? '' : wrongDate;
                this.daysQuantityValid = Number(this.daysQuantity) <= this.maxDaysCount && Number(this.daysQuantity) > 0 ? '' : 'Chart_WrongDays';
                break;
            case '2':
                this.endDateValid = this.endDate ? '' : wrongDate;
                this.daysQuantityValid = Number(this.daysQuantity) <= this.maxDaysCount && Number(this.daysQuantity) > 0 ? '' : 'Chart_WrongDays';
                break;
        }

        // console.log(this.type, 'validate')
        // console.log(this.startDateValid, 'this.startDateValid', this.endDateValid, 'this.endDateValid', this.daysQuantityValid, 'this.daysQuantityValid')

        if (this.startDateValid || this.endDateValid){
            this.translateService.get(wrongDate).subscribe(r => this.commonData.showErrors([r]))
        }

        if (this.daysQuantityValid){
            this.translateService.get(this.daysQuantityValid).subscribe(r => this.commonData.showErrors([`${r} (Min = 1, Max = ${this.maxDaysCount})`]))
        }

        return !this.endDateValid && !this.startDateValid && !this.daysQuantityValid //&& !this.skuValid && !this.wrhCodeValid && !this.itemIdValid;
    };

    //# transpile days quantity to date
    private updateDates = (): void =>{
        switch (this.type){
            case '1':
                this.updateEndDate();
                break;
            case '2':
                this.updateStartDate();
                break;
            case '3':
                this.updateStartDate();
                break;
        }
    };

    private updateEndDate = (): void => {
        this.endDate = moment.utc(this.startDate, "YYYY-MM-DD").add(Number(this.daysQuantity), 'days').format('YYYY-MM-DD')
    }

    //# update start date
    private updateStartDate = (): void => {
        this.startDate = moment.utc(this.endDate, "YYYY-MM-DD").add(-Number(this.daysQuantity), 'days').format('YYYY-MM-DD');
    }

    //# validate dates, and if all is ok emit dates
    public apply = (): void =>{
        if (!this.validate()){
            return;
        }

        this.updateDates();

        this.datesOut.emit(new PeriodSelectorModel(this.startDate, this.endDate, this.sharedGUID, this.GUID));
    };
}




// WEBPACK FOOTER //
// ./src/app/shared/components/period-selector.component/period-selector.component.ts